const DEVICE_KEY = 'empathy-calibration.v1.deviceKey';

function randomHex(bytes = 16): string {
  const arr = new Uint8Array(bytes);
  crypto.getRandomValues(arr);
  return Array.from(arr, (b) => b.toString(16).padStart(2, '0')).join('');
}

export function getOrCreateDeviceKey(): string {
  const existing = localStorage.getItem(DEVICE_KEY);
  if (existing && existing.length > 20) return existing;
  const next = `${crypto.randomUUID?.() ?? randomHex(16)}.${randomHex(16)}`;
  localStorage.setItem(DEVICE_KEY, next);
  return next;
}

export function resetDeviceKey(): string {
  localStorage.removeItem(DEVICE_KEY);
  return getOrCreateDeviceKey();
}
